'use client';
import { FC, useEffect } from 'react';
import { CatLayoutSection, CatSkeleton } from 'components/blocks-components';
import { Conditional } from '@cat-ecom/pcc-components';
import ListOfArrangements from './list-of-arrangements';
import PartsDetails from './parts-details';
import PartsCard from './parts-card';
import { LocationAddress } from 'services/location/types';
import classNames from 'classnames';
import styles from '../../parts-layout.module.scss';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import {
  CATEGORY_TYPES,
  ListOfArrangementsResponse
} from 'types/parts-diagram';

export interface PartsContentProps {
  listOfArrangementsData: ListOfArrangementsResponse;
  isCatCorp: boolean;
  dealerData?: {
    address?: LocationAddress;
  };
  locale: string;
  storefeatures;
  dealerInformation;
  isShowSourcingDetailEnabled: boolean;
  isDeliveryEnabled: boolean;
}

const PartsContent: FC<PartsContentProps> = ({
  listOfArrangementsData,
  isCatCorp,
  dealerData,
  locale,
  storefeatures,
  dealerInformation,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled
}) => {
  const { isToggle, displayCategory, setIsCatCorp, serverData, setServerData } =
    usePartDiagram();
  const partDiagramContent = classNames(styles['parts-diagram__content'], {
    [`${styles['is-full-width']}`]: isToggle
  });

  useEffect(() => {
    setIsCatCorp(isCatCorp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCatCorp]);

  useEffect(() => {
    setServerData({
      ...serverData,
      locale: locale,
      dealerData: dealerData,
      storefeatures: storefeatures.storefeatures,
      dealerInformation,
      isShowSourcingDetailEnabled: isShowSourcingDetailEnabled,
      isDeliveryEnabled: isDeliveryEnabled
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    locale,
    dealerData,
    storefeatures,
    dealerInformation,
    isShowSourcingDetailEnabled,
    isDeliveryEnabled
  ]);

  return (
    <div className={partDiagramContent} data-testid="parts-content">
      <CatLayoutSection>
        <Conditional
          test={
            listOfArrangementsData &&
            displayCategory == CATEGORY_TYPES.LISTOFARRANGEMENTS
          }
        >
          <ListOfArrangements listOfArrangementsData={listOfArrangementsData} />
        </Conditional>
        <Conditional test={displayCategory == CATEGORY_TYPES.PARTSDETAILS}>
          <PartsDetails
            dealerData={dealerData}
            locale={locale}
            listOfArrangementsData={listOfArrangementsData}
          />
        </Conditional>
        <Conditional test={displayCategory == CATEGORY_TYPES.PARTSCARDS}>
          <PartsCard />
        </Conditional>
        <Conditional test={displayCategory == CATEGORY_TYPES.LOADER}>
          <CatSkeleton size="xxl" />
        </Conditional>
      </CatLayoutSection>
    </div>
  );
};

export default PartsContent;
